import React, { useEffect, useState } from "react";
import styles from "./checkScooterEligibility.module.scss";
import FloatingSelect from "../../../atoms/floatingSelect/floatingSelect";
import GenericModal from "../../../GenericModal/index";
import { useHistory } from "react-router";
import { makeAPICall } from "../../../services/apiService";

const CheckScooterEligibility = () => {
  const history = useHistory();
  const [SDC, setSDC] = useState(null);
  const [showSDCDropdown, setShowSDCDropdown] = useState(false);
  const [SDCSelected, setSDCSelected] = useState(false);
  const [SDCList, setSDCList] = useState([]);
  const [model, setModel] = useState(null);
  const [showModelDropdown, setShowModelDropdown] = useState(false);
  const [modelSelected, setModelSelected] = useState(false);
  const [modelList, setModelList] = useState([]);
  const [isComingSoon, setIsComingSoon] = useState(false)
  const [experienceCenterList, setExperienceCenterList] = useState([])
  const [selectedExperienceCenter, setSelectedExperienceCenter] = useState(null)
  const [showExpereinceCenterDropdown, setShowExpereinceCenterDropdown] = useState(false);
  const [EXPSelected, setEXPSelected] = useState(false);

  useEffect(() => {
    loadInitialData()
  }, [])

  const loadInitialData = () => {
    fetchSDC()
    fetchScooterVariants()
  }

  function fetchSDC() {
    let url = `/api/checkEligibility/getSDC`
    let config = {
      method: "get",
      url: url,
    };


    makeAPICall(config)
      .then((resp) => {
        if (resp && resp?.data?.status === "SUCCESSFUL") {
          if (resp?.data?.data) {
            setSDCList(resp?.data?.data)
          } else {
            setSDCList([])
          }
        }

      })
      .catch((err) => {
        console.log(err)
      });
  }

  const fetchScooterVariants = () => {
    let url = `/api/checkEligibility/getScooterVariants?locale=en&country=IN`
    let config = {
      method: "get",
      url: url,
    };


    makeAPICall(config)
      .then((resp) => {
        if (resp && resp?.data?.status === "SUCCESSFUL") {
          if (resp?.data?.data?.product_variants_list) {
            setModelList(resp?.data?.data?.product_variants_list)
          } else {
            setModelList([])
          }
        }

      })
      .catch((err) => {
        console.log(err)
      });
  }


  const selectSDCLocation = (el) => {
    setSDC(el);
    setSDCSelected(true);
    setShowSDCDropdown(false);
  };

  const selectScooterModel = (el) => {
    setModel(el);
    setModelSelected(true);
    setShowModelDropdown(false);
  };

  const handleCheck = () => {
    if (!model || (!SDC && !selectedExperienceCenter)) {
      return
    }
    // if (!model || !SDC || (experienceCenterList?.length ? !selectedExperienceCenter : false)) {
    //   return
    // }
    console.log("experienceCenterList", experienceCenterList, selectedExperienceCenter)
    let url = `/api/checkEligibility/getAvailableScooters?sdc=${(!selectedExperienceCenter?.sdcCodeForXc && !selectedExperienceCenter?.mappedSdc) ? SDC?.sdc_code : (selectedExperienceCenter?.sdcCodeForXc || selectedExperienceCenter?.mappedSdc) }&variant=${model?.product_name}&variant_product_id=${model?.entity_id}`
    let config = {
      method: "get",
      url: url,
    };


    makeAPICall(config)
      .then((resp) => {
        if (resp && resp?.data?.status === "SUCCESSFUL") {
          if (resp?.data?.data?.availability_response?.length) {
            history.push({
              pathname: `/check-scooter-status`,
              state: {
                scooterList: resp?.data?.data?.availability_response,
                lastUpdated: resp?.data?.data?.last_updated,
                SDC,
                model,
                experienceCenterList,
                selectedExperienceCenter
              }
            })
          } else {
            setIsComingSoon(true)
          }
        } else {
          setIsComingSoon(true)
        }

      })
      .catch((err) => {
        console.log(err)
        setIsComingSoon(true)
      });
  }

  const handleSelectedExp = (el) => {
    setSelectedExperienceCenter(el);
    setEXPSelected(true);
    setShowExpereinceCenterDropdown(false);
  }

  function fetchExperienceCenters() {
    setSelectedExperienceCenter(null)
    setExperienceCenterList([])
    let url = `/api/checkEligibility/getExperienceCenters`
    let config = {
      method: "get",
      url: url,
      params: {
        sdc: SDC?.sdc_code,
      }
    };


    makeAPICall(config)
      .then((resp) => {
        if (resp && resp?.data?.status === "SUCCESSFUL") {
          if (resp?.data?.data) {
            setExperienceCenterList(resp?.data?.data)
          } else {
            setExperienceCenterList([])
          }
        }

      })
      .catch((err) => {
        console.log(err)
      });
  }

  useEffect(() => {

    if (SDC) {
      fetchExperienceCenters()
    }

  }, [SDC])

  return (
    <div className={styles.wrapper}>
      <img
        className={styles.backIcon}
        src="https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/extendedWarranty/BackArrowWithWhiteBackground.svg"
        alt="back"
        onClick={() => {
          history.goBack();
        }}
      />

      <div className={styles.container}>
        <h3 className={styles.title}>Check scooter availability</h3>
        {
          !isComingSoon ? (
            <>
              <div className={styles.dropdownWrapper}>
                <FloatingSelect
                  labelName="Model"
                  inputValue={model?.product_name}
                  onChange={() => setShowModelDropdown(!showModelDropdown)}
                  isSelected={modelSelected}
                />
              </div>
              <div className={styles.dropdownWrapper}>
                <FloatingSelect
                  labelName="SDC"
                  inputValue={SDC?.sdc_name}
                  onChange={() => setShowSDCDropdown(!showSDCDropdown)}
                  isSelected={SDCSelected}
                />
              </div>
              {
                true && (
                  <div className={styles.dropdownWrapper}>
                    <FloatingSelect
                      labelName="selectedExperienceCenter"
                      inputValue={selectedExperienceCenter?.businessUnitId}
                      onChange={() => {
                        experienceCenterList?.length && setShowExpereinceCenterDropdown(!showExpereinceCenterDropdown)
                      }}
                      isSelected={EXPSelected}
                      isDisabled={!experienceCenterList?.length}
                    />
                  </div>
                )
              }

            </>
          ) : (
            <div className={styles.comingSoonWrapper}>
              Coming Soon
            </div>
          )
        }
      </div>

      <div className={styles.btnWrapper}>
        <p style={{
          opacity: (selectedExperienceCenter || SDC) && model ? "1" : '0.2'
        }} className={styles.btn} onClick={handleCheck}>
          Check
        </p>
        {/* <p style={{
          opacity: !model || !SDC || (experienceCenterList?.length ? !selectedExperienceCenter : false) ? "0.2" : "1"
        }} className={styles.btn} onClick={handleCheck}>
          Check
        </p> */}
      </div>

      {showSDCDropdown && (
        <GenericModal
          onClose={() => {
            setShowSDCDropdown(false);
          }}
          showClose={false}
          botSheet={true}
        >
          <div className={styles["eb-common-div"]}>
            <div className={styles["eb-drop-down-title"]}>SDC</div>
            <div>
              {SDCList.map((el, i) => (
                <div
                  onClick={() => {
                    selectSDCLocation(el);
                  }}
                  className={styles["eb-common-single-div"]}
                  key={i}
                >
                  {el?.sdc_name}
                </div>
              ))}
            </div>
          </div>
        </GenericModal>
      )}

      {showModelDropdown && (
        <GenericModal
          onClose={() => {
            setShowModelDropdown(false);
          }}
          showClose={false}
          botSheet={true}
        >
          <div className={styles["eb-common-div"]}>
            <div className={styles["eb-drop-down-title"]}>Model</div>
            <div>
              {modelList.map((el, i) => (
                <div
                  onClick={() => {
                    selectScooterModel(el);
                  }}
                  className={styles["eb-common-single-div"]}
                  key={i}
                >

                  {el?.product_name}
                </div>
              ))}
            </div>
          </div>
        </GenericModal>
      )}

      {showExpereinceCenterDropdown && (
        <GenericModal
          onClose={() => {
            setShowExpereinceCenterDropdown(false);
          }}
          showClose={false}
          botSheet={true}
        >
          <div className={styles["eb-common-div"]}>
            <div className={styles["eb-drop-down-title"]}>Experience Centers</div>
            <div>
              {experienceCenterList.map((el, i) => (
                <div
                  onClick={() => {
                    handleSelectedExp(el);
                  }}
                  className={styles["eb-common-single-div"]}
                  key={i}
                >
                  {el?.name}
                </div>
              ))}
            </div>
          </div>
        </GenericModal>
      )}
    </div>
  );
};

export default CheckScooterEligibility;
